// src/pages/tournament/SinglesSetting.jsx
// Whether the players left over after the doubles matchups play a singles game instead of sitting out.
import React from 'react';
import { describeNextRound } from '../../utils/planShape';

function SinglesSetting({ details = {}, activePlayerCount, onSetSingles, locked }) {
    const enabled = Boolean(details.singlesEnabled);
    const nextRound = describeNextRound(activePlayerCount, details.courts, enabled);
    return (
        <section className="card singles-card" aria-label="Singles">
            <div className="singles-toggle">
                <button
                    type="button"
                    role="switch"
                    aria-checked={enabled}
                    aria-labelledby="singles-label"
                    className={`switch${enabled ? ' on' : ''}`}
                    onClick={() => onSetSingles(!enabled)}
                    disabled={locked}
                >
                    <span className="switch-knob" />
                </button>
                <div>
                    <strong id="singles-label">Singles for players sitting out</strong>
                    <p className="hint">
                        {enabled
                            ? 'When players are left over after the doubles matchups, two of them play a singles game instead of sitting out.'
                            : 'Off: players left over after the doubles matchups sit out.'}
                        {nextRound && <> Next round: {nextRound}.</>}
                    </p>
                </div>
            </div>
        </section>
    );
}

export default SinglesSetting;
